import { Button } from 'components/parts/Button';
import { PlainDialog } from 'components/parts/PlainDialog';
import CloseIcon from 'images/icon/close_white.svg';
import PinchInIcon from 'images/icon/pinch-in.svg';

import styles from './MapDialogView.module.scss';

export const MapDialogView = ({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: () => void;
}) => {
  return (
    <PlainDialog isOpen={isOpen}>
      <div className={styles.dialogHead}>
        <button
          type="button"
          className={styles.dialogCloseIconButton}
          onClick={() => {
            handleClose();
          }}
        >
          <img src={CloseIcon} alt="閉じる" className={styles.dialogCloseIcon} />
        </button>
      </div>
      <div className={styles.dialogBody}>
        <div className={styles.dialogImageWrap}>
          <img
            src={require(`components/pages/Area/images/map_area.webp`)}
            alt=""
            className={styles.dialogImage}
          />
        </div>
        <p className={styles.dialogExplanation}>
          <img src={PinchInIcon} alt="" className={styles.dialogExplanationIcon} />
          <span className={styles.dialogExplanationText}>二本指で拡大ができます</span>
        </p>
      </div>
      <div className={styles.dialogFoot}>
        <Button text="閉じる" styleType="secondary" handleClick={handleClose}></Button>
      </div>
    </PlainDialog>
  );
};
